module.exports = __webpack_public_path__ + "img/BecomeIns-2.3607803e.svg";